import React, { FunctionComponent, ReactNode } from "react";
import Analytics from "../Analytics/Analytics";
import Header from "../Header";
import Footer from "../Footer";
import { Common } from "../../types/common";
import "../../styles/main.scss"

type LayoutProps = {
  children: ReactNode;
  cssClass?: string;
  common: Common;
  isHome?: boolean;
  headerBg?: string;
};

const Layout: FunctionComponent<LayoutProps> = ({ children, cssClass, common, isHome, headerBg }) => {
  function getQueryParams(url: string) {
    const queryParams: { [key: string]: string } = {};
    const queryString = url.split("?")[1];

    if (queryString) {
      const params = queryString.split("&");

      params.forEach(function (param) {
        const keyValuePair = param.split("=");
        const key = decodeURIComponent(keyValuePair[0]);
        const value = decodeURIComponent(keyValuePair[1]);
        queryParams[key] = value;
      });
    }

    return queryParams;
  }

  const params = typeof window !== "undefined" ? getQueryParams(window.location.href) : {};

  return (
    <>
      {<Analytics />}
      <Header data={common} isHome={isHome} headerBg={headerBg} />
      <main id="mainContent" className={cssClass}>
        {children}
      </main>
      <Footer data={common} />
    </>
  )
}

export default Layout;
